<template>
    <v-row no-gutters>
        <v-container>
            <template>
                <div class="p-3">
                    <v-card>
                        <v-card-title>
                            <v-row>
                                <v-col md="4" sm="12">
                                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Cari" single-line
                                        hide-details></v-text-field>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-data-table :headers="columns" :items="rows" item-key="name" sort-by="calories"
                            class="elevation-1">
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Kelola Rubrik</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                    <v-menu offset-y close-on-content-click>
                                        <template v-slot:activator="{ on }">
                                            <v-btn color="indigo darken-4 white--text" class="mb-2 ml-2"
                                                :to="{ name: 'manage-rubric.create' }">
                                                <v-icon left>mdi-puzzle-plus</v-icon>Tambah rubrik<v-divider class="px-2"
                                                    vertical></v-divider>
                                            </v-btn>
                                        </template>

                                    </v-menu>
                                </v-toolbar>
                            </template>
                            <template v-slot:item.flag_aktif="{ item }">
                                <v-switch v-model="item.flag_aktif" inset on :disabled="item.flag_aktif"
                                    @change="onChangeSwitch(item)"
                                    :label="item.flag_aktif ? `Aktif` : `Tidak aktif`"></v-switch>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-icon color="dark" class="mr-2" @click="onEditRubric(item)">
                                    mdi-pencil
                                </v-icon>
                                <v-icon color="dark" class="mr-2" @click="onViewRubric(item)">
                                    mdi-eye
                                </v-icon>
                                <template>
                                    <div class="text-center">
                                        <v-dialog v-model="dialogView" 
                                            width="600px">
                                            <v-card>
                                                <v-toolbar
                                                    dark
                                                    color="primary"
                                                    >
                                                    <v-btn
                                                        icon
                                                        dark
                                                        @click="dialogView = false"
                                                    >
                                                        <v-icon>mdi-close</v-icon>
                                                    </v-btn>
                                                    <v-toolbar-title> Detail Rubrik</v-toolbar-title>
                                                    <v-spacer></v-spacer>
                                                    </v-toolbar>
                                                <v-card-text>
                                                    <v-card color="grey lighten-4 p-3 my-3">
                                                        <tr>
                                                            <td><strong>Nama rubrik</strong></td>
                                                            <td>&ensp;:&emsp;</td>
                                                            <td>{{ dialogViewData ? dialogViewData.nama_rubrik : ''}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Prodi</strong></td>
                                                            <td>&ensp;:&emsp;</td>
                                                            <td>{{ dialogViewData ? dialogViewData.prodi : ''}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Dibuat pada</strong></td>
                                                            <td>&ensp;:&emsp;</td>
                                                            <td>{{ dialogViewData ? $dates.dateNoDayWithTime(dialogViewData.dibuat_pada) : ''}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Diperbarui pada</strong></td>
                                                            <td>&ensp;:&emsp;</td>
                                                            <td>{{ dialogViewData ? $dates.dateNoDayWithTime(dialogViewData.diperbaharui_pada) : ''}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Status</strong></td>
                                                            <td>&ensp;:&emsp;</td>
                                                            <td><v-chip x-small :color="dialogViewData ? dialogViewData.flag_aktif == 1 ? 'green white--text' : 'red white--text' : '' "><strong>{{ dialogViewData ? dialogViewData.flag_aktif == 1 ? 'Aktif' : 'Tidak aktif' : ''  }}</strong></v-chip></td>
                                                        </tr>
                                                    </v-card>
                                                <v-simple-table>
                                                    <template>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">
                                                                    No.
                                                                </th>
                                                                <th class="text-left">
                                                                    Komponen
                                                                </th>
                                                                <th class="text-left">
                                                                    Bobot
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, index) in dialogViewData.komponen_penilaian">
                                                                <td color="indigo--text text--darken-4">{{
                                                                    index + 1 }}</td>
                                                                <td>
                                                                    {{ item.nama}}
                                                                </td>
                                                                <td>
                                                                    {{ item.bobot }}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                                </v-card-text>

                                                <v-divider></v-divider>

                                                <v-card-actions class="d-flex justify-content-center">
                                                    <v-btn color="primary" outlined text @click="dialogView = false">
                                                        Kembali
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </div>
                                </template>
                            </template>
                            <template v-slot:no-data>
                                <br>
                                Belum ada data<br>
                                <v-btn class="m-4" color="gray" @click="resetFilter">
                                    Mulai ulang
                                </v-btn>
                            </template>
                        </v-data-table>
                    </v-card>
                </div>
            </template>
        </v-container>
    </v-row>
</template>

<script>
import { serialize } from "object-to-formdata";
export default {
    data() {
        return {
            columns: [
                { text: 'No', align: 'start', value: 'no', },
                { text: 'Nama Rubrik', align: 'start', value: 'nama_rubrik', },
                { text: 'Dibuat tanggal', align: 'start', value: 'created_at', },
                { text: 'Aktif/Tidak', align: 'start', value: 'flag_aktif', },
                { text: 'Actions', align: 'start', value: 'actions', sortable: false },
            ],
            kode_jenis_surat: '',
            search: '',
            list_letters: [],
            rows: [],
            dialogView: false,
            dialogViewData: [],
            valid: true,
            datePicker1: false,
            tanggal_realisasi_mulai_kp: null
        }
    }, created() {
        this.getData()
    },
    computed: {
        format_tanggal_realisasi_mulai_kp() {
            return this.formatDate(this.tanggal_realisasi_mulai_kp);
        }
    },
    watch: {
        'search'(newValue) {
            // if (newValue) this.getData();
        }
    },
    methods: {
        getData() {
            const params = {
            };
            this.isLoading = true;
            this.axios.get("/api/rubrik", { params: params }).then((res) => {
                this.rows = res.data.data.map((el, i) => {
                    el.no = i + 1;
                    el.created_at = el.created_at ? el.created_at : '-';
                    el.flag_aktif = el.flag_aktif == 1 ? true : false;
                    return el;
                });
            }).finally(() => this.isLoading = false);
        },
        resetFilter() {
            this.search = '';
            this.getData();
        },
        getDetailRubric(row) {
            this.dialogViewData = []
            this.axios.get("/api/rubrik/"+ row.id).then((res) => {
                this.dialogViewData = res.data.data;
            }).finally(() => this.isLoading = false);
        },
        onChangeSwitch(val) {
            val ? this.activateRubric(val.id) : false;
        },
        onEditRubric(row) {
            this.$router.push({ name: 'manage-rubric.create', query: { update: row.id } });
        },
        async onViewRubric(row) {
             await this.getDetailRubric(row);
             if (this.dialogViewData){
             this.dialogView = true;
             } else {
                this.$emit("toast", "warning", "gagagl mendapatkan rubrik");
             }
        },
        resetDialog() {
            this.dialogView = false;
        },
        activateRubric(idRubrik) {
            if (idRubrik) {
                let url = "/api/rubrik/activate/" + idRubrik;
                this.isLoading = true;
                const options = {
                    indices: false,
                    nullsAsUndefineds: true,
                    booleansAsIntegers: false,
                    allowEmptyArrays: false,
                    noFilesWithArrayNotation: false,
                    dotsForObjectNotation: false,
                };
                let formData = new FormData();
                let form = {};
                form["_method"] = "put";
                formData = serialize(form, options);
                this.axios
                    .post(url, formData)
                    .then((res) => {
                        this.$emit("toast", "success", "Berhasil mengaktifkan rubrik");
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
                    .finally(() => {
                        this.isLoading = false;
                        this.getData();
                    });
            }
        },
    }
}
</script>